import React from 'react';
import { CTAButton } from './CTAButton';
export function About() {
  return <section className="w-full bg-white px-5 py-14 sm:px-6 sm:py-20" data-id="element-19" data-mp="2prgtuqbftp5v">
      <div className="mx-auto w-full max-w-2xl" data-id="element-20" data-mp="2ptkyjah5us77">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-ofm-900 sm:text-4xl" data-id="element-21" data-mp="2tssppdkwn6mi">
          Sobre la Dra. Karito
        </h2>

        <div className="mt-7 space-y-4 text-[15px] leading-relaxed text-ofm-900/75" data-id="element-22" data-mp="2ypsl8uk4oqzd">
          <p data-id="element-23" data-mp="33p5i884prefo">Durante años observó el mismo patrón en cientos de colegas.</p>
          <p className="font-bold text-ofm-900" data-id="element-24" data-mp="38p1l241ocztn">
            No era falta de conocimiento. No era falta de interés. Era falta de un
            proceso.
          </p>
          <p data-id="element-25" data-mp="3hj66g7y1hj1s">
            La mayoría conocía los aparatos. Pero muy pocos sabían exactamente cuándo
            indicar cada uno.
          </p>
          <p data-id="element-26" data-mp="3mjkie12rhd53">Por eso desarrolló el Sistema de Decisión Clínica OFM.</p>
          <p data-id="element-27" data-mp="3rhvt0e0vrrod">
            No para enseñar más teoría. Sino para convertir el diagnóstico en un
            proceso lógico, estructurado y fácil de aplicar en la consulta diaria.
          </p>
          <p data-id="element-28" data-mp="2grutpg7owoxq">
            Hoy ese mismo sistema ayuda a más de 1.200 odontólogos a tomar decisiones
            clínicas con mayor seguridad, disminuir la incertidumbre y explicar cada
            tratamiento con fundamentos claros.
          </p>
        </div>

        <p className="mt-7 border-l-4 border-ofm-600 bg-ofm-50 px-4 py-4 font-display text-lg font-bold italic leading-snug text-ofm-900 sm:text-xl" data-id="element-29" data-mp="27tso0nd0h844">
          Porque cuando existe un método, desaparece la improvisación.
        </p>

        <CTAButton className="mt-8" label="🦷 QUIERO APLICAR SU MÉTODO" subline="Acceso inmediato por $12.99 USD" data-id="element-30" data-mp="2volm35iy50du" />
      </div>
    </section>;
}